var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { composeAsyncValidators, composeValidators, } from '@/utils/libs/react-final-form/validate';
import { isAllowMegaSizeFile, isFileValid, isRequiredText, strMax, } from '@/utils/validate/conditions';
/**
 * バリデーション: チャットメッセージ入力
 */
export const hotlineChatFormMessageValid = composeValidators(isRequiredText('メッセージを入力してください'), strMax(5000, 'メッセージは5000文字以内で入力してください'));
/**
 * バリデーション: ファイル選択
 */
export const hotlineChatFormFileValid = composeValidators(isFileValid(), isAllowMegaSizeFile(100, '100MB以下のファイルを選択してください'));
/**
 * バリデーション: アップロードファイル
 */
export const hotlineChatFormUploadFileValid = (onInspectFileStatus) => composeAsyncValidators((value, allValues, meta) => __awaiter(void 0, void 0, void 0, function* () { return onInspectFileStatus(value, allValues, meta); }));
